export const number = new Intl.NumberFormat('en-IN')

export function formatDate(value: string, options?: Intl.DateTimeFormatOptions) {
  return new Intl.DateTimeFormat('en-IN', options ?? { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(value))
}

export function formatDateTime(value: string) {
  return new Intl.DateTimeFormat('en-IN', {
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(value))
}

export function percent(numerator: number, denominator: number) {
  if (!denominator) return 0
  return Math.round((numerator / denominator) * 1000) / 10
}

export function daysUntil(value: string) {
  const diff = new Date(value).getTime() - Date.now()
  return Math.ceil(diff / 86_400_000)
}

export function conditionLabel(condition: string) {
  return condition.replaceAll('_', ' ').replace(/\b\w/g, (letter) => letter.toUpperCase())
}
